<template>
  <div class="dashboard-body-futuristic">
    <!-- Header Component -->


    <!-- Main Container -->
    <main class="futuristic-container" style="flex-direction: column; padding: 1rem 2rem;">

      <!-- Main Content (PDF View) -->
      <section class="dashboard-card-futuristic dashboard-card-scrollable" style="width: 100%;">
        <div class="pdf-viewer-wrapper">

          <Teleport to="#page-action-bar">
            <button class="btn-viewer-action btn-back" @click="fileListingPage">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <line x1="19" y1="12" x2="5" y2="12"></line>
                <polyline points="12 19 5 12 12 5"></polyline>
              </svg>
              Back
            </button>
            <h1 class="page-bar-title">Acceptance Criteria</h1>
            <div class="page-bar-actions">
              <button class="btn-viewer-action" @click="exportToPDF">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                  <polyline points="14 2 14 8 20 8" />
                  <line x1="16" y1="13" x2="8" y2="13" />
                  <line x1="16" y1="17" x2="8" y2="17" />
                  <polyline points="10 9 9 9 8 9" />
                </svg>
                Download PDF
              </button>
            </div>
          </Teleport>


          <div class="pdf-content-container table-responsive" ref="documentToExport">
            <table class="pdf-content-table">
              <thead>
                <tr>
                  <th>Acceptance Criteria</th>
                  <th>Type</th>
                  <th>Reference</th>
                  <th>Clause No.</th>
                  <th>Page No</th>
                  <th>KB Match</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="tableData in tableDataList" :key="tableData.id">
                  <td><div class="cell-scroll">{{ tableData.term_condition }}</div></td>
                  <td><div class="cell-scroll">{{ tableData.condition_type }}</div></td>
                  <td><div class="cell-scroll">{{ tableData.reference }}</div></td>
                  <td><div class="cell-scroll">{{ tableData.clause_no }}</div></td>
                  <td><div class="cell-scroll">{{ tableData.page_no }}</div></td>
                  <td>
                    <div class="cell-scroll">
                      <span v-if="tableData.matching_percentage" class="match-badge"
                        :class="matchClass(tableData.matching_percentage)">
                        {{ tableData.matching_percentage }}
                      </span>
                      <span v-else class="match-pending">—</span>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          

        </div>
      </section>
    </main>
  </div>
</template>

<script>
import axios from "axios";
import html2pdf from "html2pdf.js";




export default {
  name: "AcceptanceCriteria",
  components: { },

  data() {
    return {
      tableDataList: [],
    };
  },

  props: {
    getAccessToken: Function,
  },

  created() {
    // Hide global header for this page too
  },

  mounted() {
    this.populateCriteriaData();
  },

  methods: {

    exportToPDF: function () {
      if (this.$refs.documentToExport) {
        html2pdf(this.$refs.documentToExport, {
          margin: 1,
          filename: "generated-document.pdf",
          image: { type: "jpeg", quality: 0.98 },
          html2canvas: { scale: 2 },
          jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
        });
      }
    },

    fileUploadPage: function () {
      this.$router.push({ name: 'Home' });
    },
    // Back to the bid's Analysis tab; carry status/from so the sidebar keeps its highlight.
    fileListingPage: function () {
      const { status, from } = this.$route.query;
      this.$router.push({
        name: 'BidDetails',
        params: { pdf_id: this.$route.params.pdf_id },
        query: { tab: 'analysis', ...(status ? { status } : {}), ...(from ? { from } : {}) },
      });
    },


    populateCriteriaData: function () {
      const pdf_id = this.$route.params.pdf_id; // Get ID from route parameters

      if (!pdf_id) return; // Guard clause

      axios.get(this.$API_URL + `/user/pdf-criteria-details?pdf_id=${pdf_id}`, {
        headers: {
          Authorization: "Bearer " + this.getAccessToken()
        }
      })
        .then(res => {
          this.tableDataList = res.data.items; // backend ka table JSON
        })
        .catch(err => console.error(err));
    },

    // Colour-code the KB match badge by percentage band.
    matchClass(value) {
      const n = parseInt(String(value).replace(/[^0-9]/g, ''), 10);
      if (isNaN(n)) return 'match-low';
      if (n >= 70) return 'match-high';
      if (n >= 40) return 'match-mid';
      return 'match-low';
    }
  }

};
</script>

<style scoped>
/* Light-blue table header. */
.pdf-content-table :deep(thead th) {
  background: #e0f2fe;
  color: #0c4a6e;
}

.match-badge {
  display: inline-block;
  min-width: 46px;
  text-align: center;
  font-weight: 700;
  font-size: 0.8rem;
  padding: 0.2rem 0.6rem;
  border-radius: 20px;
}

.match-high {
  background: rgba(16, 185, 129, 0.15);
  color: #059669;
}

.match-mid {
  background: rgba(245, 158, 11, 0.15);
  color: #d97706;
}

.match-low {
  background: rgba(244, 63, 94, 0.15);
  color: #e11d48;
}

.match-pending {
  color: #64748b;
  font-weight: 700;
}
</style>